<template>
    <div class="info-warpper">
        <div class="bg-white" v-if="info">
            <el-descriptions title="基本信息" direction="vertical" :column="4" border>
                <el-descriptions-item label="姓名">{{ info.name }}</el-descriptions-item>
                <el-descriptions-item label="手机号">{{ info.phone }}</el-descriptions-item>
                <el-descriptions-item label="年龄">{{ info.age ? info.age : '-' }}</el-descriptions-item>
                <el-descriptions-item label="地址">
                    {{ info.xiaoqu_name }}-{{ info.building_name }}-{{ info.element_name }}-{{ info.room_name }}
                </el-descriptions-item>
                <el-descriptions-item label="手表IMEI">{{ info.IMEI }}</el-descriptions-item>
                <el-descriptions-item label="专属管家">
                    <div class="flex align-center justify-between">
                        <p> {{ info.guanjia_name }}</p>
                        <el-button size="small" type="danger" @click="guanjiaDialog = true"
                                   v-if="user.power === 5">修改
                        </el-button>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="专业人员">
                    <div class="flex align-center justify-between">
                        <p>{{ info.exclusive_personnel_name }} - {{ info.exclusive_personnel_phone }}</p>
                        <el-button size="small" type="danger" @click="zhuanyeDialog = true">修改</el-button>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="紧急联系人">
                    <div class="flex align-center justify-between">
                        <p> {{ info.emergency_contact ? info.emergency_contact : '-' }}</p>
                        <el-button size="small" type="danger" @click="lianxiDialog = true">修改</el-button>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="属性分类" :span="2">
                    <div class="flex align-center justify-between">
                        <p> {{ attribute | attribute }}</p>
                        <el-button size="small" type="danger" @click="shuxingDialog = true">修改</el-button>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="发送短信对象" :span="2">
                    <div class="flex align-center justify-between">
                        <p> {{ sms_state | sms_state }}</p>
                        <el-button size="small" type="danger" @click="smsObjDialog = true">修改</el-button>
                    </div>
                </el-descriptions-item>
            </el-descriptions>
            <div class="margin-top">
                <el-tabs v-model="activeName" type="card">
                    <el-tab-pane label="健康监测情况" name="first">
                        <div class="flex flex-direction padding-xs">
                            <div class="flex justify-between">
                                <xin-lv-chart class="echarts" :values="xinlv"></xin-lv-chart>
                                <xue-ya-chart class="echarts" :values="xueya"></xue-ya-chart>
                            </div>
                            <div class="flex justify-between margin-top-sm">
                                <xue-yang-chart class="echarts" :values="xueyang"></xue-yang-chart>
                                <ti-wen-chart class="echarts" :values="tiwen"></ti-wen-chart>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="历史病情" name="second">
                        <el-table
                                :data="historicalCondition"
                                header-row-class-name="table-header"
                                row-class-name="table-row"
                                alig="center"
                                border
                                style="width: 100%"
                        >
                            <el-table-column label="病种" prop="ill_name"></el-table-column>
                            <el-table-column label="持续时间" prop="time_long"></el-table-column>
                            <el-table-column label="目前用药" prop="medicine_name"></el-table-column>
                            <el-table-column label="操作" width="220">
                                <template slot-scope="scope">
                                    <div class="table-operate">
                                        <el-button
                                                size="small"
                                                type="danger"
                                                @click="editItem(scope.row)"
                                        >编辑
                                        </el-button>
                                        <el-button
                                                size="small"
                                                type="primary"
                                                @click="deleteItem(scope.row.jumin_id)"
                                        >删除
                                        </el-button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="flex align-center justify-around padding">
                            <el-button type="primary" @click="bingDialog = true">添加</el-button>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="五脏筛查情況" name="third">
                        <h3 class="margin-bottom-sm">心脏</h3>
                        <el-checkbox-group v-model="screening.item1">
                            <el-checkbox label="心悸气短"></el-checkbox>
                            <el-checkbox label="失眠多梦"></el-checkbox>
                            <el-checkbox label="记忆减退"></el-checkbox>
                            <el-checkbox label="面色苍白"></el-checkbox>
                            <el-checkbox label="肢冷畏寒"></el-checkbox>
                            <el-checkbox label="神疲三力"></el-checkbox>
                            <el-checkbox label="胸闷气短"></el-checkbox>
                            <el-checkbox label="五心烦热"></el-checkbox>
                            <el-checkbox label="大便千结"></el-checkbox>
                        </el-checkbox-group>
                        <el-divider></el-divider>
                        <h3 class="margin-bottom-sm">肝脏</h3>
                        <el-checkbox-group v-model="screening.item2">
                            <el-checkbox label="急躁易怒"></el-checkbox>
                            <el-checkbox label="胸闷嗳气"></el-checkbox>
                            <el-checkbox label="纳食减少"></el-checkbox>
                            <el-checkbox label="两目干涩"></el-checkbox>
                            <el-checkbox label="视物模糊"></el-checkbox>
                            <el-checkbox label="肢体麻木"></el-checkbox>
                            <el-checkbox label="眼眶暗黑"></el-checkbox>
                            <el-checkbox label="头晕目眩"></el-checkbox>
                            <el-checkbox label="舌苔厚腻"></el-checkbox>
                        </el-checkbox-group>
                        <el-divider></el-divider>
                        <h3 class="margin-bottom-sm">脾脏</h3>
                        <el-checkbox-group v-model="screening.item3">
                            <el-checkbox label="咳嗽生痰"></el-checkbox>
                            <el-checkbox label="易患感冒"></el-checkbox>
                            <el-checkbox label="自汗畏风"></el-checkbox>
                            <el-checkbox label="身倦乏力"></el-checkbox>
                            <el-checkbox label="皮肤干枯"></el-checkbox>
                            <el-checkbox label="痰多而咳"></el-checkbox>
                            <el-checkbox label="食少口腻"></el-checkbox>
                            <el-checkbox label="食欲不振"></el-checkbox>
                            <el-checkbox label="面色萎黄"></el-checkbox>
                        </el-checkbox-group>

                        <el-divider></el-divider>

                        <h3 class="margin-bottom-sm"> 肺脏</h3>
                        <el-checkbox-group v-model="screening.item4">
                            <el-checkbox label="咳嗽生痰"></el-checkbox>
                            <el-checkbox label="易患感冒"></el-checkbox>
                            <el-checkbox label="自汗畏风"></el-checkbox>
                            <el-checkbox label="身倦乏力"></el-checkbox>
                            <el-checkbox label="皮肤干枯"></el-checkbox>
                            <el-checkbox label="痰多而咳"></el-checkbox>
                            <el-checkbox label="食少口腻"></el-checkbox>
                            <el-checkbox label="食欲不振"></el-checkbox>
                            <el-checkbox label="面色萎黄"></el-checkbox>
                        </el-checkbox-group>
                        <el-divider></el-divider>
                        <h3 class="margin-bottom-sm">肾脏</h3>
                        <el-checkbox-group v-model="screening.item5">
                            <el-checkbox label="眩晕健忘"></el-checkbox>
                            <el-checkbox label="腰膝酸痛"></el-checkbox>
                            <el-checkbox label="耳鸣重听"></el-checkbox>
                            <el-checkbox label="小便频数"></el-checkbox>
                            <el-checkbox label="气喘盗汗"></el-checkbox>
                            <el-checkbox label="发毛脱落"></el-checkbox>
                            <el-checkbox label="倦卧嗜睡"></el-checkbox>
                            <el-checkbox label="精神萎靡"></el-checkbox>
                            <el-checkbox label="自汗盗汗"></el-checkbox>
                        </el-checkbox-group>
                        <div class="flex align-center justify-around padding">
                            <el-button type="primary" @click="saveScreening">保存</el-button>
                        </div>

                    </el-tab-pane>
                    <el-tab-pane label="服务需求情況" name="fourth">

                        <el-table
                                :data="server"
                                header-row-class-name="table-header"
                                row-class-name="table-row"
                                alig="center"
                                border
                                style="width: 100%"
                        >
                            <el-table-column label="服务社区" prop="name"></el-table-column>
                            <el-table-column label="服务频次" prop="time">
                                <template slot-scope="scope">
                                    <div class="table-operate">
                                        <el-radio-group v-model="scope.row.time">
                                            <el-radio :label="1">随时</el-radio>
                                            <el-radio :label="2">每日</el-radio>
                                            <el-radio :label="3">每周</el-radio>
                                            <el-radio :label="4">每月</el-radio>
                                        </el-radio-group>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="付费意愿" prop="state">
                                <template slot-scope="scope">
                                    <div class="table-operate">
                                        <el-radio-group v-model="scope.row.state">
                                            <el-radio :label="1">愿意</el-radio>
                                            <el-radio :label="2">不愿意</el-radio>
                                        </el-radio-group>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="flex align-center justify-around padding">
                            <el-button type="primary" @click="saveServe">保存</el-button>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="健康指标设置" name="five">
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
                            <el-descriptions title="体温指标设置" direction="vertical" :column="5" border>
<!--                                <el-descriptions-item label="下限报警值">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.tiwen_alarm_value_lower">-->
<!--                                            <template slot="prepend">低于</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="下限预警区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.tiwen_warning_value_lower_l">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.tiwen_warning_value_lower_h">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="正常区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.tiwen_value_lower">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.tiwen_value_higher">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="上限预警区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.tiwen_warning_value_higher_l">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.tiwen_warning_value_higher_h">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="上限报警值">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.tiwen_alarm_value_higher">-->
<!--                                            <template slot="prepend">高于</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->

                                <el-descriptions-item label="体温波动率">
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="" prop="name">
                                                <el-input v-model="ruleForm.tiwen_warning_lv">
                                                    <template slot="prepend">预警</template>
                                                    <template slot="append">%</template>
                                                </el-input>
                                            </el-form-item>

                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="" prop="name">
                                                <el-input v-model="ruleForm.tiwen_alarm_lv">
                                                    <template slot="prepend">报警</template>
                                                    <template slot="append">%</template>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-descriptions-item>

                            </el-descriptions>

                            <el-divider></el-divider>


                            <el-descriptions title="心率指标设置" direction="vertical" :column="5" border>
<!--                                <el-descriptions-item label="下限报警值">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xinlv_alarm_value_lower">-->
<!--                                            <template slot="prepend">低于</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="下限预警区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xinlv_warning_value_lower_l">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xinlv_warning_value_lower_h">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="正常区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xinlv_value_lower">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xinlv_value_higher">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="上限预警区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xinlv_warning_value_higher_l">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xinlv_warning_value_higher_h">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="上限报警值">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xinlv_alarm_value_higher">-->
<!--                                            <template slot="prepend">高于</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->

                                <el-descriptions-item label="心率波动率">
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="" prop="name">
                                                <el-input v-model="ruleForm.xinlv_warning_lv">
                                                    <template slot="prepend">预警</template>
                                                    <template slot="append">%</template>
                                                </el-input>
                                            </el-form-item>

                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="" prop="name">
                                                <el-input v-model="ruleForm.xinlv_alarm_lv">
                                                    <template slot="prepend">报警</template>
                                                    <template slot="append">%</template>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-descriptions-item>

                            </el-descriptions>
                            <el-divider></el-divider>
<!--                            <el-descriptions title="低压指标设置" direction="vertical" :column="5" border>-->
<!--                                <el-descriptions-item label="下限报警值">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_low_alarm_value_lower">-->
<!--                                            <template slot="prepend">低于</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="下限预警区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_low_warning_value_lower_l">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_low_warning_value_lower_h">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="正常区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_low_value_lower">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_low_value_higher">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="上限预警区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_low_warning_value_higher_l">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_low_warning_value_higher_h">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="上限报警值">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_low_alarm_value_higher">-->
<!--                                            <template slot="prepend">高于</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                            </el-descriptions>-->
<!--                            <el-divider></el-divider>-->
                            <el-descriptions title="高压指标设置" direction="vertical" :column="5" border>
<!--                                <el-descriptions-item label="下限报警值">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_high_alarm_value_lower">-->
<!--                                            <template slot="prepend">低于</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="下限预警区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_high_warning_value_lower_l">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_high_warning_value_lower_h">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="正常区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_high_value_lower">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_high_value_higher">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="上限预警区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_high_warning_value_higher_l">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_high_warning_value_higher_h">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="上限报警值">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueya_high_alarm_value_higher">-->
<!--                                            <template slot="prepend">高于</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->

                                <el-descriptions-item label="血压波动率">
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="" prop="name">
                                                <el-input v-model="ruleForm.xueya_warning_lv">
                                                    <template slot="prepend">预警</template>
                                                    <template slot="append">%</template>
                                                </el-input>
                                            </el-form-item>

                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="" prop="name">
                                                <el-input v-model="ruleForm.xueya_alarm_lv">
                                                    <template slot="prepend">报警</template>
                                                    <template slot="append">%</template>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-descriptions-item>
                            </el-descriptions>
                            <el-divider></el-divider>
                            <el-descriptions title="血氧指标设置" direction="vertical" :column="5" border>
<!--                                <el-descriptions-item label="下限报警值">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueyang_alarm_value_lower">-->
<!--                                            <template slot="prepend">低于</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="下限预警区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueyang_warning_value_lower_l">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueyang_warning_value_lower_h">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="正常区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueyang_value_lower">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueyang_value_higher">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="上限预警区间">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueyang_warning_value_higher_l">-->
<!--                                            <template slot="prepend">最低</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueyang_warning_value_higher_h">-->
<!--                                            <template slot="prepend">最高</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
<!--                                <el-descriptions-item label="上限报警值">-->
<!--                                    <el-form-item label="" prop="name">-->
<!--                                        <el-input v-model="ruleForm.xueyang_alarm_value_higher">-->
<!--                                            <template slot="prepend">高于</template>-->
<!--                                        </el-input>-->
<!--                                    </el-form-item>-->
<!--                                </el-descriptions-item>-->
                                <el-descriptions-item label="血氧波动率">
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="" prop="name">
                                                <el-input v-model="ruleForm.xueyang_warning_lv">
                                                    <template slot="prepend">预警</template>
                                                    <template slot="append">%</template>
                                                </el-input>
                                            </el-form-item>

                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="" prop="name">
                                                <el-input v-model="ruleForm.xueyang_alarm_lv">
                                                    <template slot="prepend">报警</template>
                                                    <template slot="append">%</template>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-descriptions-item>
                            </el-descriptions>

                            <el-form-item class="flex align-center justify-around" label-width="0">
                                <el-button class="padding-lr-xl margin-top" type="primary"
                                           @click="submitForm('ruleForm')">提交
                                </el-button>
                            </el-form-item>

                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <bingDialog
                :setId="setId"
                :setItem="setItem"
                :bingDialog="bingDialog"
                @cancelDialog="cancelDialog"
        />
        <guanjiaDialog
            :admin_id="admin_id"
            :accountList="accountList"
            :guanjiaDialog="guanjiaDialog"
            @cancelDialog="cancelDialog"
        />
        <zhuanyeDialog
                :exclusive_personnel_id="exclusive_personnel_id"
                :exclusivePersonnelList="exclusivePersonnelList"
                :zhuanyeDialog="zhuanyeDialog"
                @cancelDialog="cancelDialog"
        />

        <lianxiDialog
                :lxrName="lxrName"
                :lxrPhone="lxrPhone"
                :lianxiDialog="lianxiDialog"
                @cancelDialog="cancelDialog"
        />


        <ShuxingDialog
            :s_id="attribute"
            :shuxingDialog="shuxingDialog"
            @cancelDialog="cancelDialog"/>

        <SmsObjDialog
            :s_id="sms_state"
            :smsObjDialog="smsObjDialog"
            @cancelDialog="cancelDialog"/>




    </div>
</template>

<script>

import {
    getExclusivePersonnelList,
    getJuminIllList,
    getWatchPeopleDetail,
    updateWatchPeopleDetail4,
    updateWatchPeopleDetail5, updateWatchPeopleDetail6
} from "@/api/service";
import bingDialog from "@/views/serve/dialog/bingDialog.vue";
import guanjiaDialog from "@/views/serve/dialog/guanjiaDialog.vue";
import zhuanyeDialog from "@/views/serve/dialog/zhuanyeDialog.vue";
import lianxiDialog from "@/views/serve/dialog/lianxiDialog.vue";
import XinLvChart from "@/views/serve/dialog/XinLvChart.vue";
import TiWenChart from "@/views/serve/dialog/TiWenChart.vue";
import XueYaChart from "@/views/serve/dialog/XueYaChart.vue";
import XueYangChart from "@/views/serve/dialog/XueYangChart.vue";
import {getAdminList} from "@/api/login";
import SmsObjDialog from "@/views/serve/dialog/smsObjDialog";
import {filesCN, jvminShuxingList, smsObjectList} from "@/utils/utils";
import ShuxingDialog from "@/views/serve/dialog/shuxingDialog";

export default {
    name: "service-object",
    data() {
        return {
            id: '',
            info: null,
            historicalCondition: [],
            xinlv: [],
            xueya: [],
            xueyang: [],
            tiwen: [],
            activeName: 'first',
            setId: 0,
            setItem: {},
            bingDialog: false,
            zhuanyeDialog: false,
            lianxiDialog: false,
            guanjiaDialog: false,
            shuxingDialog: false,
            smsObjDialog: false,
            screening: {
                item1: [],
                item2: [],
                item3: [],
                item4: [],
                item5: [],
            },

            server: [
                {name: '适老化改造', time: '', state: ''},
                {name: '营养配餐（自主）', time: '', state: ''},
                {name: '营养配餐（买送）', time: '', state: ''},
                {name: '健康监测', time: '', state: ''},
                {name: '专家义诊', time: '', state: ''},
                {name: '健康讲堂', time: '', state: ''},
                {name: '康复指导', time: '', state: ''},
                {name: '科学锻炼', time: '', state: ''},
                {name: '康复理疗', time: '', state: ''},
                {name: '用药咨询', time: '', state: ''},
                {name: '就医陪诊', time: '', state: ''},
                {name: '心灵陪护', time: '', state: ''},
                {name: '专业陪护', time: '', state: ''},
                {name: '体征监测', time: '', state: ''},
                {name: '健康顾问', time: '', state: ''},
                {name: '居家急救', time: '', state: ''},
            ],

            ruleForm: {
                tiwen_value_lower: '',
                tiwen_value_higher: '',
                tiwen_warning_value_lower_l: '',
                tiwen_warning_value_lower_h: '',
                tiwen_warning_value_higher_l: '',
                tiwen_warning_value_higher_h: '',
                tiwen_alarm_value_lower: '',
                tiwen_alarm_value_higher: '',

                xinlv_value_lower: '',
                xinlv_value_higher: '',
                xinlv_warning_value_lower_l: '',
                xinlv_warning_value_lower_h: '',
                xinlv_warning_value_higher_l: '',
                xinlv_warning_value_higher_h: '',
                xinlv_alarm_value_lower: '',
                xinlv_alarm_value_higher: '',

                xueya_low_alarm_value_lower: '',   //   低压 报警下限
                xueya_low_warning_value_lower_l: '',   //   低压下限 预警 低 30
                xueya_low_warning_value_lower_h: '',   //   低压下限 预警 高 39
                xueya_low_value_lower: '',     // 低压 正常 低    40
                xueya_low_value_higher: '',   //  低压 正常 高  50
                xueya_low_warning_value_higher_l: '',   //  低压上限 预警 低 51
                xueya_low_warning_value_higher_h: '',   //  低压上限 预警 高 60
                xueya_low_alarm_value_higher: '',   //  低压 报警上线限

                xueya_high_alarm_value_lower: '',   //  高压 报警下限
                xueya_high_warning_value_lower_l: '',   //  高压下限 预警 低 30
                xueya_high_warning_value_lower_h: '',   //  高压下限 预警 高 39
                xueya_high_value_lower: '',   //    高压 正常 低 120
                xueya_high_value_higher: '',   //   高压 正常 高 130
                xueya_high_warning_value_higher_l: '',   //  高压上限 预警 低 51
                xueya_high_warning_value_higher_h: '',   //  高压上限 预警 高 60
                xueya_high_alarm_value_higher: '',   //  高压 报警上线限

                xueyang_value_lower: '',
                xueyang_value_higher: '',
                xueyang_warning_value_lower_l: '',
                xueyang_warning_value_lower_h: '',
                xueyang_warning_value_higher_l: '',
                xueyang_warning_value_higher_h: '',
                xueyang_alarm_value_lower: '',
                xueyang_alarm_value_higher: '',

                tiwen_warning_lv:'', //   '体温预警波动率',
                tiwen_alarm_lv:'', //   '体温报警波动率',
                xinlv_warning_lv:'', //   '心率预警波动率',
                xinlv_alarm_lv:'', //   '心率报警波动率',
                xueya_warning_lv:'', //   '血压预警波动率',
                xueya_alarm_lv:'', //   '血压报警波动率',
                xueyang_warning_lv:'', //   '血氧预警波动率',
                xueyang_alarm_lv:'', //   '血氧报警波动率',

            },
            rules: {
                tiwen_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_warning_value_lower_l: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_warning_value_lower_h: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_warning_value_higher_l: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_warning_value_higher_h: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_alarm_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_alarm_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_warning_value_lower_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_warning_value_lower_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_warning_value_higher_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_warning_value_higher_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_alarm_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_alarm_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_alarm_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_warning_value_lower_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_warning_value_lower_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_warning_value_higher_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_warning_value_higher_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_low_alarm_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_alarm_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_warning_value_lower_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_warning_value_lower_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_warning_value_higher_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_warning_value_higher_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_high_alarm_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_warning_value_lower_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_warning_value_lower_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_warning_value_higher_l: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_warning_value_higher_h: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_alarm_value_lower: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_alarm_value_higher: [{required: true, message: '请输入', trigger: 'blur'}],

                tiwen_warning_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                tiwen_alarm_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_warning_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                xinlv_alarm_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_warning_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                xueya_alarm_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_warning_lv: [{required: true, message: '请输入', trigger: 'blur'}],
                xueyang_alarm_lv: [{required: true, message: '请输入', trigger: 'blur'}],
            },

            exclusivePersonnelList: [],
            exclusive_personnel_id: 0,
            accountList: [],
            admin_id: 0,

            lxrName: '',
            lxrPhone: '',

            attribute: '',
            sms_state: '',

        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.id = this.$route.params.id
        this.$emit("setIndex", '/home/service-object', "预警中心 / 服务对象", false);
        this.getDetail()
        this.getBingList()
        this.getExclusivePersonnelList()
        if (this.user.power === 5) this.getAdminList()

    },
    components: {
        ShuxingDialog,
        SmsObjDialog,
        XueYangChart, XueYaChart, TiWenChart, XinLvChart,
        bingDialog, zhuanyeDialog, lianxiDialog,guanjiaDialog
    },
    methods: {
        //  获取物业管家列表
        async getAdminList() {
            let _list = await getAdminList('', '', 6, 1, 999)
            this.accountList = _list.data
        },
        //  获取专业人员列表
        async getExclusivePersonnelList() {
            let _list = await getExclusivePersonnelList(1, 999)
            this.exclusivePersonnelList = _list.data
        },
        async getDetail() {
            const res = await getWatchPeopleDetail(this.id)
            this.info = res.data
            this.tiwen = res.data.tiwen
            this.xinlv = res.data.xinlv
            this.xueya = res.data.xueya
            this.xueyang = res.data.xueyang
            this.attribute = res.data.attribute
            this.sms_state = res.data.sms_state
            this.exclusive_personnel_id = res.data.exclusive_personnel_id ? res.data.exclusive_personnel_id : 0
            if(res.data.emergency_contact){
                let _arr = res.data.emergency_contact.split('-')
                this.lxrName = _arr[0]
                this.lxrPhone = _arr[1]
            }

            if (res.data.wuzang) {
                this.screening = JSON.parse(res.data.wuzang)
            }
            if (res.data.service_demand_situation) {
                this.server = JSON.parse(res.data.service_demand_situation)
            }


            this.ruleForm = {
                tiwen_value_lower: res.data.tiwen_value_lower,
                tiwen_value_higher: res.data.tiwen_value_higher,
                tiwen_warning_value_lower_l: res.data.tiwen_warning_value_lower_l,
                tiwen_warning_value_lower_h: res.data.tiwen_warning_value_lower_h,
                tiwen_warning_value_higher_l: res.data.tiwen_warning_value_higher_l,
                tiwen_warning_value_higher_h: res.data.tiwen_warning_value_higher_h,
                tiwen_alarm_value_lower: res.data.tiwen_alarm_value_lower,
                tiwen_alarm_value_higher: res.data.tiwen_alarm_value_higher,
                xinlv_value_lower: res.data.xinlv_value_lower,
                xinlv_value_higher: res.data.xinlv_value_higher,
                xinlv_warning_value_lower_l: res.data.xinlv_warning_value_lower_l,
                xinlv_warning_value_lower_h: res.data.xinlv_warning_value_lower_h,
                xinlv_warning_value_higher_l: res.data.xinlv_warning_value_higher_l,
                xinlv_warning_value_higher_h: res.data.xinlv_warning_value_higher_h,
                xinlv_alarm_value_lower: res.data.xinlv_alarm_value_lower,
                xinlv_alarm_value_higher: res.data.xinlv_alarm_value_higher,
                xueya_low_alarm_value_lower: res.data.xueya_low_alarm_value_lower,
                xueya_low_warning_value_lower_l: res.data.xueya_low_warning_value_lower_l,
                xueya_low_warning_value_lower_h: res.data.xueya_low_warning_value_lower_h,
                xueya_low_value_lower: res.data.xueya_low_value_lower,
                xueya_low_value_higher: res.data.xueya_low_value_higher,
                xueya_low_warning_value_higher_l: res.data.xueya_low_warning_value_higher_l,
                xueya_low_warning_value_higher_h: res.data.xueya_low_warning_value_higher_h,
                xueya_low_alarm_value_higher: res.data.xueya_low_alarm_value_higher,
                xueya_high_alarm_value_lower: res.data.xueya_high_alarm_value_lower,
                xueya_high_warning_value_lower_l: res.data.xueya_high_warning_value_lower_l,
                xueya_high_warning_value_lower_h: res.data.xueya_high_warning_value_lower_h,
                xueya_high_value_lower: res.data.xueya_high_value_lower,
                xueya_high_value_higher: res.data.xueya_high_value_higher,
                xueya_high_warning_value_higher_l: res.data.xueya_high_warning_value_higher_l,
                xueya_high_warning_value_higher_h: res.data.xueya_high_warning_value_higher_h,
                xueya_high_alarm_value_higher: res.data.xueya_high_alarm_value_higher,
                xueyang_value_lower: res.data.xueyang_value_lower,
                xueyang_value_higher: res.data.xueyang_value_higher,
                xueyang_warning_value_lower_l: res.data.xueyang_warning_value_lower_l,
                xueyang_warning_value_lower_h: res.data.xueyang_warning_value_lower_h,
                xueyang_warning_value_higher_l: res.data.xueyang_warning_value_higher_l,
                xueyang_warning_value_higher_h: res.data.xueyang_warning_value_higher_h,
                xueyang_alarm_value_lower: res.data.xueyang_alarm_value_lower,
                xueyang_alarm_value_higher: res.data.xueyang_alarm_value_higher,

                tiwen_warning_lv : res.data.tiwen_warning_lv,
                tiwen_alarm_lv : res.data.tiwen_alarm_lv,
                xinlv_warning_lv : res.data.xinlv_warning_lv,
                xinlv_alarm_lv : res.data.xinlv_alarm_lv,
                xueya_warning_lv : res.data.xueya_warning_lv,
                xueya_alarm_lv : res.data.xueya_alarm_lv,
                xueyang_warning_lv : res.data.xueyang_warning_lv,
                xueyang_alarm_lv : res.data.xueyang_alarm_lv,
            }
        },
        //  编辑
        editItem(obj) {
            this.setItem = obj;
            this.setId = obj.id;
            this.bingDialog = true;
        },
        // 病种 信息编辑后回调
        cancelDialog(val) {
            if (val) {
                this.setId = 0;
                this.setItem = {};
                this.bingDialog = false;
                this.lianxiDialog = false;
                this.zhuanyeDialog = false;
                this.guanjiaDialog = false;
                this.shuxingDialog = false;
                this.smsObjDialog = false;
                this.getBingList()
                this.getDetail()
            } else {
                this.setId = 0;
                this.setItem = {};
                this.bingDialog = false;
                this.lianxiDialog = false;
                this.zhuanyeDialog = false;
                this.guanjiaDialog = false;
                this.shuxingDialog = false;
                this.smsObjDialog = false;
            }
        },

        //  获取列表
        async getBingList() {
            let _list = await getJuminIllList(this.id)
            this.historicalCondition = _list.data
        },

        //  保存 五脏筛查情況
        async saveScreening() {
            const res = await updateWatchPeopleDetail4(this.id, JSON.stringify(this.screening))
            if (res.status === 200) this.$message.success('操作成功')
        },
        //  保存 服务需求情况
        async saveServe() {
            const res = await updateWatchPeopleDetail5(this.id, JSON.stringify(this.server))
            if (res.status === 200) this.$message.success('操作成功')
        },


        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await updateWatchPeopleDetail6(
                this.ruleForm.tiwen_value_lower,
                this.ruleForm.tiwen_value_higher,
                this.ruleForm.tiwen_warning_value_lower_l,
                this.ruleForm.tiwen_warning_value_lower_h,
                this.ruleForm.tiwen_warning_value_higher_l,
                this.ruleForm.tiwen_warning_value_higher_h,
                this.ruleForm.tiwen_alarm_value_lower,
                this.ruleForm.tiwen_alarm_value_higher,
                this.ruleForm.xinlv_value_lower,
                this.ruleForm.xinlv_value_higher,
                this.ruleForm.xinlv_warning_value_lower_l,
                this.ruleForm.xinlv_warning_value_lower_h,
                this.ruleForm.xinlv_warning_value_higher_l,
                this.ruleForm.xinlv_warning_value_higher_h,
                this.ruleForm.xinlv_alarm_value_lower,
                this.ruleForm.xinlv_alarm_value_higher,
                this.ruleForm.xueya_low_alarm_value_lower,
                this.ruleForm.xueya_low_warning_value_lower_l,
                this.ruleForm.xueya_low_warning_value_lower_h,
                this.ruleForm.xueya_low_value_lower,
                this.ruleForm.xueya_low_value_higher,
                this.ruleForm.xueya_low_warning_value_higher_l,
                this.ruleForm.xueya_low_warning_value_higher_h,
                this.ruleForm.xueya_low_alarm_value_higher,
                this.ruleForm.xueya_high_alarm_value_lower,
                this.ruleForm.xueya_high_warning_value_lower_l,
                this.ruleForm.xueya_high_warning_value_lower_h,
                this.ruleForm.xueya_high_value_lower,
                this.ruleForm.xueya_high_value_higher,
                this.ruleForm.xueya_high_warning_value_higher_l,
                this.ruleForm.xueya_high_warning_value_higher_h,
                this.ruleForm.xueya_high_alarm_value_higher,
                this.ruleForm.xueyang_value_lower,
                this.ruleForm.xueyang_value_higher,
                this.ruleForm.xueyang_warning_value_lower_l,
                this.ruleForm.xueyang_warning_value_lower_h,
                this.ruleForm.xueyang_warning_value_higher_l,
                this.ruleForm.xueyang_warning_value_higher_h,
                this.ruleForm.xueyang_alarm_value_lower,
                this.ruleForm.xueyang_alarm_value_higher,

                this.ruleForm.tiwen_warning_lv,
                this.ruleForm.tiwen_alarm_lv,
                this.ruleForm.xinlv_warning_lv,
                this.ruleForm.xinlv_alarm_lv,
                this.ruleForm.xueya_warning_lv,
                this.ruleForm.xueya_alarm_lv,
                this.ruleForm.xueyang_warning_lv,
                this.ruleForm.xueyang_alarm_lv,

                this.id
            );
            this.$message.success(_state.info);
        }


    },
    filters: {
        attribute(val) {
            return val ? filesCN(Number(val),jvminShuxingList) : '--'
        },
        sms_state(val) {
            return val ? filesCN(Number(val),smsObjectList) : '--'
        }
    },
    watch: {},
}
</script>

<style scoped lang="scss">
.echarts {
  width: 48%;
  height: 300px;
}
</style>


